import transferCallContent from './TransferCallContent';

const transferCall = {
  name: 'Transfer Call',
  Content: transferCallContent,
  setInitialContent: (content = {}) => {
    return {
      transferTarget: content.transferTarget || ''
    };
  },
  valid: () => {
    return true;
  }
};

export default transferCall;
